export default __webpack_public_path__ + "static/media/death_valley_thumb.a03cc7e6.jpeg";